import { Component } from '@angular/core';
import { OrderDetailActionsComponent, OrderDetailsService } from '@spartacus/order/components';
import { Observable } from 'rxjs';
import { CustomOrderDetailsService } from '../custom-order-details.service';

@Component({
  selector: 'cx-order-details-actions',
  templateUrl: './custom-order-detail-actions.component.html',
  standalone: false
})
export class CustomOrderDetailActionsComponent extends OrderDetailActionsComponent {
  constructor(
    protected orderDetailsService: OrderDetailsService,
    protected customOrderDetailsService: CustomOrderDetailsService,
  ) {
    super(orderDetailsService);
  }

  order$: Observable<any> = this.orderDetailsService.getOrderDetails();
}
